import React from 'react';
import { useSelector } from 'react-redux';
import { Select, Flex, Typography, Button, message, Card, Divider, Alert } from 'antd';

import { Course } from '../Course';
import { Supervision } from '../Course_Supervision';

import { semesterStruct } from './struct';

const { Title } = Typography;

export const Semester = ({
  semesterDetail,
  teaching,
  supervision,
  removeSemester,
  setSemesterName,
  updateTeaching,
  updateSupervision
}) => {
  const [messageApi, contextHolder] = message.useMessage();

  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { semester: semesters } = staticData;

  const { semester, tempSemester } = semesterDetail;

  const underloadMessage =
    semesterDetail['underload'] || semesterDetail.underload || null;

  return (
    <Card {...semesterStruct.wrapper}>
      <Flex {...semesterStruct.header}>
        {contextHolder}

        <Flex {...semesterStruct.headline}>
          <Title {...semesterStruct.title}>
            Semester~
            {semester === 1
              ? 'Spring'
              : semester === 2
                ? 'Summer'
                : semester === 3
                  ? 'Autumn'
                  : ''}
          </Title>
          {tempSemester ? (
            <Select
              {...semesterStruct.selectSemesters}
              onChange={(value) => {
                value
                  ? setSemesterName(Number(value), tempSemester)
                  : messageApi.error("Empty can't be a semester name");
              }}
              options={semesters}
            />
          ) : (
            <></>
          )}
        </Flex>
        {!tempSemester ? (
          <Button
            {...semesterStruct.removeButton}
            onClick={() => removeSemester(semester)}
          >
            Remove
          </Button>
        ) : (
          <></>
        )}
      </Flex>

      {underloadMessage ? (
        <>
          <br />
          <Alert
            type="warning"
            showIcon
            message="Underload Warning"
            description={underloadMessage}
          />
        </>
      ) : (
        <></>
      )}

      <br />

      {/* Table A ~ Teaching Evaluation */}
      {teaching ? (
        <>
          <Title level={5} style={{ marginBottom: 12 }}>
            Teaching Evaluation
          </Title>
          <Course
            courses={teaching}
            semesterName={semester}
            updateSemester={updateTeaching}
          />
        </>
      ) : (
        <></>
      )}

      <Divider style={{ margin: '20px 0' }} />

      {/* Table B ~ Supervision */}
      {supervision ? (
        <>
          <Title level={5} style={{ marginBottom: 12 }}>
            Supervision
          </Title>
          <Supervision
            courses={supervision}
            semesterName={semester}
            updateSemester={updateSupervision}
          />
        </>
      ) : (
        <></>
      )}
    </Card>
  );
};